<template>
  <div class="contact">
  
    <div class="center">
      <div class="header flex">
        <!-- <mymap></mymap> -->
        <div v-for="(i,index) in img"
             :key="index"
             style="flex:1">
          <span>
            <img :src="i.url">
            <p>{{i.name}}</p>
          </span>
        </div>
      </div>
      <div class='input flex'>
        <div style="flex:1;text-align: center;">
          <p>感谢您联系我们！！</p>
          <el-input placeholder="姓名:"></el-input>
          <el-input placeholder="邮箱:"></el-input>
          <el-input placeholder="标题:"></el-input>
          <el-input type="textarea"
                    :rows="4"
                    placeholder="我该如何帮助您呢？"
                    v-model="textarea"
                    resize="none"
                    style="  width: 25rem;margin-top: 1rem;">
          </el-input>
        </div>
        <div style="flex:1;text-align: center;">
          <mymap style="border-radius: 0.5rem;"></mymap>
          <p style="margin-top:1rem;margin-bottom:1rem">深圳市宝安区宝运达物流信息大厦706</p>
        </div>
      </div>
      
    </div>
  
  </div>
</template>
<script>
import map from '../../components/PrivateComponent/map'
export default {
  data() {
    return {
        textarea:"",
      img: [
        {
          url: require('../../assets/imges/电 话(1).png'),
          name: '0755-2308-0620'
        },
        {
          url: require('../../assets/imges/邮件(1).png'),
          name: 'yscy@feitianpcb.com'
        },
        {
          url: require('../../assets/imges/定位(1).png'),
          name: '深圳市宝安区宝运达物流信息大厦706'
        }
      ]
    }
  },
  components: {
    mymap: map
  }
}
</script>
<style lang="scss" scoped>
.contact {

  // 定位和联系方式
  .center {
    width: 70%;
    margin: auto;
  }
  .input {
    width: 70%;
    margin: auto;

    div {
      .el-input {
        width: 25rem;
        margin-top: 1rem;
      }
    }
  }
  // 上部分表格图
  .header {
    div {
      margin-top: 1rem;
      margin-bottom: 4rem;
      span {
        text-align: center;
      }
      img {
        margin-left: 45%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/contact.vue